<template>
  <div class="confirm-center">
    <!-- TABS//S -->
    <div class="tab-design">
      <ul>
        <li flex fic>
          <router-link :to="{ name: 'mypage' }">{{
            $t("mypage.menu[0]")
          }}</router-link>
        </li>
        <li flex fic>
          <router-link to="/mypage/auth">{{
            $t("mypage.menu[1]")
          }}</router-link>
        </li>
        <li flex fic>
          <router-link to="/mypage/contactInfo">{{
            $t("mypage.menu[2]")
          }}</router-link>
        </li>
      </ul>
    </div>
    <!-- TABS//E -->
    <div v-if="isForeign === null">
      <vs-tabs>
        <vs-tab :label="$t('mypage.human[0]')">
          <local-center />
        </vs-tab>
        <vs-tab :label="$t('mypage.human[1]')">
          <foreign-center />
        </vs-tab>
      </vs-tabs>
    </div>
    <div v-else-if="isForeign === 'N' || !isForeign">
      <local-center />
    </div>
    <div v-else-if="isForeign === 'Y'">
      <foreign-center />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import localCenter from "./confirmCenter.local";
import foreignCenter from "./confirmCenter.foreign";

export default {
  data: () => ({
    foreign: false,
  }),
  computed: {
    ...mapGetters(["userInfo"]),
    isForeign() {
      return this.userInfo.foreignYn;
    },
  },
  components: {
    localCenter,
    foreignCenter,
  },
};
</script>

<style lang="scss" scoped>
.confirm-center {
  & ::v-deep .vs-tabs--ul {
    display: flex;
    justify-content: center;
  }
  & ::v-deep .vs-tabs--li button {
    font-weight: bold;
    opacity: 1;
    text-shadow: 1px 1.7px 5px rgba(14, 80, 173, 0.32);
    transition: all 0.2s ease;
    color: #fff;
    display: block;
    padding-top: 8px;
    padding-bottom: 12px;
    font-size: 15px;
  }
}
</style>
